module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-53.186c1d76.svg";